import { render, staticRenderFns } from "./dispalyRules.vue?vue&type=template&id=184f21ae&scoped=true&"
import script from "./dispalyRules.vue?vue&type=script&lang=ts&"
export * from "./dispalyRules.vue?vue&type=script&lang=ts&"
import style0 from "./dispalyRules.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./dispalyRules.vue?vue&type=style&index=1&id=184f21ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f21ae",
  null
  
)

export default component.exports